import { useApplyProfile } from '@/hooks/useApplyProfile';

/**
 * UPROF-1.2 → reworked in UPROF-1.7.
 *
 * Keeps the auth store (the source the header reads via `useAuth`) and the
 * `['userProfile']` query cache in sync after a profile/avatar change.
 *
 * History: 1.2 implemented this via `useAuth().fetchProfile()`, which flips the
 * auth store's global `isLoading` — and `AuthGuard` treats that as "unmount the
 * page", so every save remounted `/profile` and the edit form re-seeded from a
 * stale cache (the regression fixed by 1.7). This now delegates to a **silent**
 * refresh (`useApplyProfile().refreshProfile`): one `GET /users/me` (which includes
 * RBAC) → updates both caches → NO `isLoading` flip, NO remount, NO refetch race.
 *
 * Prefer `useApplyProfile().applyProfile(response)` directly when you already hold
 * the mutation response (zero network); use this only for paths with no body in
 * hand (cross-tab pings, avatar change, currency sync).
 */
export function useProfileSync(): () => Promise<void> {
  const { refreshProfile } = useApplyProfile();
  return refreshProfile;
}
